import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { store } from '../../redux/store';

const getPersistData = () => {
  const reduxState = store.getState();
  const reduxPermission = get(reduxState, 'auth.permissions');
  const reduxMe = get(reduxState, 'auth.me');
  const reduxToken = get(reduxState, 'auth.token');

  const persist = JSON.parse(localStorage.getItem('persist:auth') || '{}');
  const persistMe = JSON.parse(persist.me || '{}');
  const persistPermissions = JSON.parse(persist.permissions || '{}');
  const persistTokens = JSON.parse(persist.token || '{}');

  // Handle on first login, redux value not stored on persist yet

  const me = isEmpty(persistMe) ? reduxMe : persistMe;
  const permissions = isEmpty(persistPermissions)
    ? reduxPermission
    : persistPermissions;
  const tokens = isEmpty(persistTokens) ? reduxToken : persistTokens;

  const persistAudiences = get(
    me,
    'user_details.user_metadata.audiences',
    [],
  ).map(x => x.identifier);

  return { persistAudiences, tokens, permissions };
};

const checkPermission = (key, checkModules) => {
  const { permissions } = getPersistData();
  const data = key.split(':');

  if (!checkModules) {
    return get(permissions, data[0], false);
  }
  if (get(permissions, data[0], []).find(x => x === data[1])) {
    return true;
  }
  return false;
};

export default {
  getPersistData,
  checkPermission,
};
